import { useEffect, useRef } from 'react';

import { useUserStore } from '../stores/userStore';

/**
 * Hydrates authentication state from a persisted token in localStorage.
 * - Reads either `authToken` or legacy `ce-marking-auth-token`
 * - Calls `handleGitHubLogin(token)` if a token is present and the user is not authenticated
 * - Idempotent across re-renders
 */
export function useAuthHydration(): void {
  const { isAuthenticated, handleGitHubLogin } = useUserStore();
  const hasHydratedRef = useRef(false);

  useEffect(() => {
    if (hasHydratedRef.current) return;
    hasHydratedRef.current = true;

    try {
      const token =
        localStorage.getItem('authToken') || localStorage.getItem('ce-marking-auth-token');
      if (token && !isAuthenticated) {
        handleGitHubLogin(token);
      }
    } catch (e) {
      // Best-effort hydration; do not crash app on storage errors
      console.error('Failed to hydrate auth from localStorage', e);
    }
  }, [isAuthenticated, handleGitHubLogin]);
}

export default useAuthHydration;
